class FishyScrollToTop extends HTMLElement {
    #listeners;
    #cancelScroll;
    #geometry;

    connectedCallback() {
        this.#listeners?.abort();
        this.#cancelScroll?.();
        this.#geometry?.disconnect();
        this.#listeners = new AbortController();
        const { signal } = this.#listeners;
        const view = this.ownerDocument.defaultView;
        let frame = null;
        const cancelScroll = () => {
            if (frame !== null) view.cancelAnimationFrame(frame);
            frame = null;
        };
        this.#cancelScroll = cancelScroll;
        for (const type of ["wheel", "touchstart", "pointerdown", "keydown", "pagehide"]) {
            view.addEventListener(type, cancelScroll, { passive: true, signal });
        }
        const document = this.ownerDocument;
        const columns = [...document.querySelectorAll("#document-content > section > div")];
        if (!columns.length) {
            const content = document.querySelector("#guide-content") ?? document.getElementById("content");
            if (content) columns.push(content);
        }
        const project = () => {
            const hidden = view.scrollY <= 320;
            if (this.hidden !== hidden) this.hidden = hidden;
        };
        const position = () => {
            const right = Math.max(0, ...columns.map(column => column.getBoundingClientRect().right));
            // Keep the 48px button beside the text, or against the viewport edge.
            this.style.right = `${Math.max(16, document.documentElement.clientWidth - right - 64)}px`;
            project();
        };
        this.#geometry = new ResizeObserver(position);
        for (const column of columns) this.#geometry.observe(column);
        this.#geometry.observe(document.documentElement);
        view.addEventListener("resize", position, { signal });
        view.addEventListener("scroll", project, { passive: true, signal });
        view.addEventListener("pageshow", position, { signal });
        this.addEventListener("click", (event) => {
            if (!event.target.closest("button")) return;
            // Move keyboard navigation out of the control before it disappears.
            this.ownerDocument.getElementById("home-link")?.focus({ preventScroll: true });
            cancelScroll();
            if (view.matchMedia("(prefers-reduced-motion: reduce)").matches) {
                view.scrollTo({ top: 0, behavior: "instant" });
                return;
            }
            const startY = view.scrollY;
            const startTime = view.performance.now();
            const animate = (now) => {
                const progress = Math.min(1, (now - startTime) / 200);
                view.scrollTo({ top: startY * (1 - progress) ** 3, behavior: "instant" });
                frame = progress < 1 ? view.requestAnimationFrame(animate) : null;
            };
            frame = view.requestAnimationFrame(animate);
        }, { signal });
        position();
    }

    disconnectedCallback() {
        this.#geometry?.disconnect();
        this.#geometry = null;
        this.#cancelScroll?.();
        this.#cancelScroll = null;
        this.#listeners?.abort();
        this.#listeners = null;
    }
}

export function registerScrollToTop() {
    if (!customElements.get("fishy-scroll-to-top")) {
        customElements.define("fishy-scroll-to-top", FishyScrollToTop);
    }
}
